import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider, useAuth } from "@/lib/auth";
import { DateRangeProvider } from "@/lib/dateRange";
import { Shell } from "@/components/layout/Shell";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Apps from "@/pages/Apps";
import AppDetail from "@/pages/AppDetail";
import TeamsPage from "@/pages/TeamsPage";
import PeoplePage from "@/pages/PeoplePage";
import TeamDetail from "@/pages/TeamDetail";
import MemberProfile from "@/pages/MemberProfile";
import MyProfile from "@/pages/MyProfile";
import Reports from "@/pages/Reports";
import Review from "@/pages/Review";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { member, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-nb-bg" />;
  if (!member) return <Navigate to="/login" replace />;
  return children;
}

function Landing() {
  const { role } = useAuth();
  // Overview is for Admin / IT Admin; route others to a page they can use.
  if (role === "team_lead") return <Navigate to="/teams" replace />;
  if (role === "member") return <MemberProfile selfView />;
  return <Overview />;
}

function App() {
  return (
    <AuthProvider>
      <DateRangeProvider>
        <TooltipProvider delayDuration={150}>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <Protected>
                    <Shell />
                  </Protected>
                }
              >
                <Route index element={<Landing />} />
                <Route path="apps" element={<Apps />} />
                <Route path="apps/:id" element={<AppDetail />} />
                <Route path="teams" element={<TeamsPage />} />
                <Route path="people" element={<PeoplePage />} />
                <Route path="team" element={<Navigate to="/teams" replace />} />
                <Route path="teams/:id" element={<TeamDetail />} />
                <Route path="members" element={<Navigate to="/people" replace />} />
                <Route path="members/:id" element={<MemberProfile />} />
                <Route path="reports" element={<Reports />} />
                <Route path="me" element={<MyProfile />} />
                <Route path="review" element={<Review />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </TooltipProvider>
      </DateRangeProvider>
    </AuthProvider>
  );
}

export default App;
